module.exports = __webpack_public_path__ + "static/media/ehr.9f39a.png";